<template>
    <div class="acceptance-dialog basic-dialog">
        <el-dialog
            :title="title"
            :visible="visible"
            @update:visible="handleUpdateVisible"
            width="560px"
            :close-on-click-modal="false"
            :destroy-on-close="true"
        >
            <div class="tip">{{ tip }}</div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleFormRef" label-width="100px" class="acceptance-form">
                <el-form-item :label="item.label" :prop="getProp(item)" v-for="item in formOptions">
                    <!-- 文本框 - textarea -->
                    <el-input
                        type="textarea"
                        v-model="ruleForm.text"
                        :placeholder="item.desc"
                        resize="none"
                        :rows="7"
                        show-word-limit
                        maxlength="500"
                        v-if="item.type === 'textarea'"
                    ></el-input>

                    <!-- 评分 -->
                    <div class="score-box" v-if="item.type === 'score'">
                        <i
                            :class="['iconfont', { light: ruleForm.score && item <= ruleForm.score }]"
                            v-for="item in 5"
                            :key="item"
                            @mouseenter="ruleForm.score = item"
                            @mouseleave="handleValidateScore"
                        >
                            &#xe7e7;
                        </i>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleUpdateVisible(false)">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        let checkText = (rule, value, callback) => {
            if (!this.required) return callback();

            if (!value) {
                const textOpton = this.formOptions.find((item) => item.type === "textarea");

                return callback(new Error(`请输入${textOpton?.label || ""}`));
            }

            callback();
        };

        let checkScore = (rule, value, callback) => {
            if (!value || value <= 0) {
                return callback(new Error("请设置评分"));
            }

            callback();
        };

        return {
            ruleForm: {
                text: "",
                score: 0,
            },
            rules: {
                text: [{ validator: checkText, trigger: "blur" }],
                score: [{ validator: checkScore, trigger: "blur" }],
            },
        };
    },

    props: {
        visible: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            default: "",
        },

        formOptions: {
            type: Array,
            default: () => [],
        },

        tip: {
            type: String,
            default: "",
        },

        required: {
            type: Boolean,
            default: true,
        },
    },

    methods: {
        handleUpdateVisible(val) {
            this.$emit("update:visible", val);

            if (!val) {
                this.ruleForm = {
                    text: "",
                    score: 0,
                };
            }
        },

        getProp(option) {
            const propMap = {
                textarea: "text",
                score: "score",
            };

            return propMap[option.type];
        },

        // 校验评分
        handleValidateScore() {
            this.$refs.ruleFormRef?.validateField?.(["score"]);
        },

        handleConfirm() {
            this.$refs.ruleFormRef.validate((valid) => {
                if (valid) {
                    this.$emit("confirm", { ...this.ruleForm });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.acceptance-dialog {
    ::v-deep .el-dialog__header {
        border-bottom: 1px solid #e6e7eb;
        padding: 24px 30px;

        .el-dialog__title {
            font-weight: 500;
            font-size: 16px;
            color: #606266;
        }

        .el-dialog__close {
            right: 30px;
            font-size: 21px;
        }
    }

    ::v-deep .el-dialog__body {
        padding: 16px 24px 40px 30px;
    }

    ::v-deep .el-dialog__footer {
        border-top: 1px solid #e6e7eb;
        padding: 24px 24px 40px;

        .el-button {
            min-width: 96px;

            &.el-button--primary {
                background: linear-gradient(270deg, #594fed 0%, #291ce7 100%);
                border-color: #291ce7;
            }
        }
    }

    .tip {
        margin-bottom: 14px;
        font-weight: 500;
        font-size: 14px;
        color: #ff0000;
    }

    .acceptance-form {
        ::v-deep .el-form-item {
            display: flex;
            // align-items: center;

            .el-form-item__label {
                width: fit-content !important;
                font-weight: 500;
                font-size: 14px;
                color: #262626;
            }

            .el-form-item__content {
                margin-left: 0 !important;
                flex: 1;
            }
        }

        .score-box {
            height: 40px;
            line-height: 40px;

            i.iconfont {
                color: #e4e4e4;
                cursor: pointer;

                & + .iconfont {
                    margin-left: 5px;
                }

                &.light {
                    color: #fcbd09;
                }
            }
        }
    }
}
</style>
